import React from "react";

const SITE_EMAIL = process.env.REACT_APP_SITE_EMAIL;

class LandingFooter extends React.Component {
    render() {
        return (
            <>
                <footer className="bg-light">
                    <div className="container">
                        <div className="f-items default-padding">
                            <div className="row">
                                <div className="col-md-4 col-sm-6 item equal-height">
                                    <div className="f-item about">
                                        <h4>About</h4>
                                        <p>
                                            UShort is an URL shortening service which is easy to use and free forever.
                                        </p>
                                        <ul>
                                            <li>
                                                <p>Email <span><a href={"mailto:" + SITE_EMAIL}>{SITE_EMAIL}</a></span></p>
                                            </li>
                                            <li>
                                                <p>Office <span>Gurgaon, India.</span></p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 item equal-height"></div>
                                <div className="col-md-2 col-sm-6 item equal-height">
                                    <div className="f-item link">
                                        <h4>Links</h4>
                                        <ul>
                                            <li>
                                                <a href="/faq"><i className="ti-angle-right"></i>FAQ</a>
                                            </li>
                                            <li>
                                                <a href="/terms"><i className="ti-angle-right"></i>Terms & Conditions</a>
                                            </li>
                                            <li>
                                                <a href="/privacy"><i className="ti-angle-right"></i>Privacy Policy</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-2 col-sm-6 item equal-height">
                                    <div className="f-item link">
                                        <h4>Account</h4>
                                        <ul>
                                            <li>
                                                <a href="/signin"><i className="ti-angle-right"></i>Signin</a>
                                            </li>
                                            <li>
                                                <a href="/signup"><i className="ti-angle-right"></i>Signup</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <p><strong>Copyright &copy; <script>document.write(new Date().getFullYear());</script> UShort </strong></p>
                                </div>
                                <div className="col-md-6 text-right link">
                                    <ul>
                                        <li>
                                            <a href="/terms">Terms & Conditions</a>
                                        </li>
                                        <li>
                                            <a href="/support">Support</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        );
    }
}

export default LandingFooter;